import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _Icon;
var _excluded = ["avatar", "color", "countryIcon", "disabled", "dotColor", "icon", "iconType", "label", "onDelete", "size", "type"];
/* eslint-disable sort-keys */
import React, { forwardRef } from 'react';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import { Dot } from '../common/Dot';
import { Icon } from '../Icon';
import { CountryIcon } from '../CountryIcon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var padding = {
  'avatar-lg': '4px 12px 4px 6px',
  'badgeColor-avatar-lg': '4px 10px 4px 8px',
  'avatar-md': '2px 10px 2px 4px',
  'badgeColor-avatar-md': '2px 8px 2px 6px',
  'avatar-sm': '2px 8px 2px 3px',
  'badgeColor-avatar-sm': '2px 6px 2px 4px',
  'country-lg': '4px 12px 4px 6px',
  'badgeColor-country-lg': '4px 10px 4px 8px',
  'country-md': '2px 10px 2px 4px',
  'badgeColor-country-md': '2px 8px 2px 6px',
  'country-sm': '2px 8px 2px 3px',
  'badgeColor-country-sm': '2px 6px 2px 4px',
  'dot-lg': '4px 12px 4px 10px',
  'badgeColor-dot-lg': '4px 10px 4px 8px',
  'dot-md': '2px 10px 2px 8px',
  'badgeColor-dot-md': '2px 8px 2px 6px',
  'dot-sm': '2px 8px 2px 6px',
  'badgeColor-dot-sm': '2px 6px 2px 4px',
  'iconLeading-lg': '4px 12px 4px 10px',
  'badgeColor-iconLeading-lg': '4px 10px 4px 8px',
  'iconLeading-md': '2px 10px 2px 8px',
  'badgeColor-iconLeading-md': '2px 8px 2px 6px',
  'iconLeading-sm': '2px 8px 2px 6px',
  'badgeColor-iconLeading-sm': '2px 6px 2px 4px',
  'iconTrailing-lg': '4px 10px 4px 12px',
  'badgeColor-iconTrailing-lg': '4px 8px 4px 10px',
  'iconTrailing-md': '2px 6px 2px 10px',
  'badgeColor-iconTrailing-md': '2px 6px 2px 8px',
  'iconTrailing-sm': '2px 6px 2px 8px',
  'badgeColor-iconTrailing-sm': '2px 4px 2px 6px',
  'only-lg': '8px',
  'badgeColor-only-lg': '8px',
  'only-md': '6px',
  'badgeColor-only-md': '6px',
  'only-sm': '5px',
  'badgeColor-only-sm': '5px',
  'undefined-lg': '4px 12px 4px 12px',
  'badgeColor-undefined-lg': '4px 10px 4px 10px',
  'undefined-md': '2px 10px 2px 10px',
  'badgeColor-undefined-md': '2px 8px 2px 8px',
  'undefined-sm': '2px 8px 2px 8px',
  'badgeColor-undefined-sm': '2px 6px 2px 6px',
  'xclose-lg': '4px 6px 4px 12px',
  'badgeColor-xclose-lg': '4px 6px 4px 10px',
  'xclose-md': '2px 4px 2px 10px',
  'badgeColor-xclose-md': '2px 4px 2px 8px',
  'xclose-sm': '2px 3px 2px 8px',
  'badgeColor-xclose-sm': '2px 3px 2px 6px'
};
export var BadgeBase = /*#__PURE__*/forwardRef(function Button(props, ref) {
  var avatar = props.avatar,
    _props$color = props.color,
    color = _props$color === void 0 ? 'gray' : _props$color,
    countryIconId = props.countryIcon,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    dotColor = props.dotColor,
    iconId = props.icon,
    iconType = props.iconType,
    label = props.label,
    onDelete = props.onDelete,
    _props$size = props.size,
    size = _props$size === void 0 ? 'sm' : _props$size,
    _props$type = props.type,
    type = _props$type === void 0 ? 'pillOutline' : _props$type,
    other = _objectWithoutProperties(props, _excluded);

  // Prevent boolean on DOM element console log
  other.hover = props.hover ? 'true' : '';
  var key = "".concat(iconType, "-").concat(size);
  if (type === 'badgeColor') key = "badgeColor-".concat(iconType, "-").concat(size);
  var variant = 'outlined';
  if (type === 'pillColor') variant = 'filled';
  if (type === 'badgeColor') variant = 'badgeColor';
  if (iconType === 'xclose') {
    return /*#__PURE__*/_jsx(Chip, _extends({
      color: color,
      deleteIcon: iconId ? /*#__PURE__*/_jsx(Icon, {
        iconId: iconId
      }) : _Icon || (_Icon = /*#__PURE__*/_jsx(Icon, {
        iconId: "XClose"
      })),
      label: label,
      onDelete: onDelete,
      ref: ref,
      size: size,
      sx: {
        gap: '2px',
        '.MuiChip-deleteIcon': {
          height: '12px !important',
          '.MuiSvgIcon-root': {
            margin: '4px',
            width: '12px !important'
          }
        },
        opacity: disabled ? '70%' : '100%',
        padding: padding[key]
      },
      variant: variant
    }, other));
  }
  if (iconType === 'iconTrailing') return /*#__PURE__*/_jsx(Chip, _extends({
    color: color,
    label: /*#__PURE__*/_jsxs(Stack, {
      alignItems: "center",
      columnGap: "4px",
      direction: "row",
      children: [label, iconId && /*#__PURE__*/_jsx(Icon, {
        iconId: iconId,
        size: 12
      })]
    }),
    onDelete: onDelete,
    ref: ref,
    size: size,
    sx: {
      gap: '4px',
      opacity: disabled ? '70%' : '100%',
      padding: padding[key]
    },
    variant: variant
  }, other));
  if (iconType === 'avatar') return /*#__PURE__*/_jsx(Chip, _extends({
    avatar: avatar,
    color: color,
    label: label,
    ref: ref,
    size: size,
    sx: {
      gap: '6px',
      opacity: disabled ? '70%' : '100%',
      padding: padding[key]
    },
    variant: variant
  }, other));
  if (iconType === 'only') {
    var width = '0px';
    if (size === 'sm') {
      width = '24px';
    } else if (size === 'md') {
      width = '26px';
    } else if (size === 'lg') {
      width = '30px';
    }
    return /*#__PURE__*/_jsx(Chip, _extends({
      color: color,
      icon: iconId && /*#__PURE__*/_jsx(Icon, {
        iconId: iconId,
        size: 12
      }),
      ref: ref,
      size: size,
      sx: {
        '.MuiChip-icon': {
          marginLeft: '4px'
        },
        gap: '4px',
        opacity: disabled ? '70%' : '100%',
        padding: padding[key],
        width: width
      },
      variant: variant
    }, other));
  }
  if (iconType === 'dot') {
    return /*#__PURE__*/_jsx(Chip, _extends({
      color: color,
      icon: /*#__PURE__*/_jsx(Dot, {
        color: dotColor,
        size: 6,
        sx: {
          mr: '4px'
        }
      }),
      label: label,
      ref: ref,
      size: size,
      sx: {
        opacity: disabled ? '70%' : '100%',
        padding: padding[key]
      },
      variant: variant
    }, other));
  }
  if (iconId || countryIconId) {
    return /*#__PURE__*/_jsx(Chip, _extends({
      color: color,
      icon: iconType === 'country' ? countryIconId && /*#__PURE__*/_jsx(CountryIcon, {
        id: countryIconId,
        size: 16
      }) : iconId && /*#__PURE__*/_jsx(Icon, {
        iconId: iconId,
        size: 12
      }),
      label: label,
      ref: ref,
      size: size,
      sx: {
        gap: iconType === 'country' ? '6px' : '4px',
        opacity: disabled ? '70%' : '100%',
        padding: padding[key]
      },
      variant: variant
    }, other));
  }
  return /*#__PURE__*/_jsx(Chip, _extends({
    color: color,
    label: label,
    ref: ref,
    size: size,
    sx: {
      opacity: disabled ? '70%' : '100%',
      padding: padding[key]
    },
    variant: variant
  }, other));
});